import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: Object.assign({
    hack: false
  }, window.state),
  mutations: {
    hack: (state, value) => {
      state.hack = value
    }
  },
  actions: {
    toggleHacks(context) {
      context.commit('hack', !context.state.hack);
    }
  },
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
})

export default store
